import React, { useState } from "react";
import styled from "styled-components";
import {
    Tabs,
    Input,
    Select,
    Switch,
    Table,
    Button,
    Row,
    Col,
    Space,
    Tag,
    Popconfirm,
} from "antd";
import {
    SearchOutlined,
    EditOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const AddEditAnnouncement = () => {
    const history = useHistory();
    const [activeTab, setActiveTab] = useState("all");
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [importantFilter, setImportantFilter] = useState(false);

    const [formData, setFormData] = useState({
        title: "",
        level: "General",
        description: "",
        sendTo: "All Employees",
    });

    const [tableData, setTableData] = useState([
        {
            key: 1,
            title: "General announcement regarding shift change",
            dateTime: "24th Aug 2024; 08:12 AM",
            level: "General",
            status: "Published",
            description: "Sample description",
        },
        {
            key: 2,
            title: "Important system update",
            dateTime: "24th Aug 2024; 08:12 AM",
            level: "Important",
            status: "Draft",
            description: "Important description",
        },
    ]);

    /* ================= ADD ================= */

    const handleAdd = () => {
        setIsEditMode(false);
        setFormData({
            title: "",
            level: "General",
            description: "",
            sendTo: "All Employees",
        });
        setIsFormVisible(true);
    };

    /* ================= EDIT ================= */

    const handleEdit = (record) => {
        setIsEditMode(true);
        setFormData({
            ...record,
        });
        setIsFormVisible(true);
    };

    /* ================= DELETE ================= */

    const handleDelete = (key) => {
        const filtered = tableData.filter((item) => item.key !== key);
        setTableData(filtered);
    };

    /* ================= SAVE ================= */

    const handleSave = () => {
        if (isEditMode) {
            const updated = tableData.map((item) =>
                item.key === formData.key ? formData : item
            );
            setTableData(updated);
        } else {
            setTableData([
                ...tableData,
                {
                    ...formData,
                    key: Date.now(),
                    dateTime: "24th Aug 2024; 08:12 AM",
                    status: "Draft",
                },
            ]);
        }

        setIsFormVisible(false);
    };

    /* ================= TABLE ================= */

    const columns = [
        { title: "Title", dataIndex: "title" },
        { title: "Date & Time", dataIndex: "dateTime" },
        {
            title: "Level",
            dataIndex: "level"
        },
        {
            title: "Status",
            dataIndex: "status"
        },
        {
            title: "",
            render: (_, record) => (
                <Space>
                    <Button
                        type="text"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                    />
                    <Popconfirm
                        title="Delete this announcement?"
                        onConfirm={() => handleDelete(record.key)}
                    >
                        <Button type="text" danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Wrapper>
            {!isFormVisible ? (
                <>
                    {/* HEADER */}
                    <div className="header">
                        <p>Announcement</p>

                        <span
                            className="back-dashboard"
                            onClick={() => history.push("/dashboard")}

                        >
                            Back to Dashboard
                        </span>
                    </div>


                    {/* TABS */}
                    <Tabs activeKey={activeTab} onChange={setActiveTab}>
                        <TabPane tab="All" key="all" />
                        <TabPane tab="Mine" key="mine" />
                    </Tabs>

                    {/* FILTERS */}
                    <Row className="filter-row" align="middle">
                        {/* Left Side Filters */}
                        <div className="left-filters">
                            <Input
                                placeholder="Search"
                                prefix={<SearchOutlined />}
                                className="input"
                            />

                            <Select placeholder="Status" className="select">
                                <Option value="Published">Published</Option>
                                <Option value="Draft">Draft</Option>
                            </Select>
                        </div>

                        {/* Right Side Controls */}
                        <div className="right-controls">
                            <Space>
                                <span>Important</span>
                                <Switch
                                    checked={importantFilter}
                                    onChange={setImportantFilter}
                                />
                            </Space>

                            {activeTab !== "all" && (
                                <Button type="primary" onClick={handleAdd}>
                                    Add Announcement
                                </Button>
                            )}
                        </div>
                    </Row>


                    {/* TABLE */}
                    <Table columns={columns} dataSource={tableData} pagination={false} />
                </>
            ) : (
                <>
                    {/* BREADCRUMB */}
                    <div className="breadcrumb">
                        <span
                            className="parent"
                            onClick={() => {
                                setIsFormVisible(false);
                                setActiveTab("all");
                            }}
                        >
                            Announcement
                        </span>
                        <span className="divider">›</span>
                        <span className="active">
                            {isEditMode ? "Editing Announcement" : "Adding Announcement"}
                        </span>
                    </div>

                    {/* FORM */}
                    <Row gutter={24} className="form-row">
                        <Col span={16}>
                            <label>Title</label>
                            <Input
                                value={formData.title}
                                onChange={(e) =>
                                    setFormData({ ...formData, title: e.target.value })
                                }
                            />
                        </Col>

                        <Col span={8}>
                            <label>
                                Level <InfoCircleOutlined />
                            </label>
                            <Select
                                value={formData.level}
                                onChange={(value) =>
                                    setFormData({ ...formData, level: value })
                                }
                            >
                                <Option value="General">General</Option>
                                <Option value="Important">Important</Option>
                            </Select>
                        </Col>
                    </Row>

                    <div className="form-section">
                        <label>Description</label>
                        <TextArea
                            rows={5}
                            value={formData.description}
                            onChange={(e) =>
                                setFormData({ ...formData, description: e.target.value })
                            }
                        />
                    </div>

                    <div className="form-section">
                        <label>Send announcement to</label>
                        <Input value={formData.sendTo} disabled />
                    </div>

                    {/* FOOTER */}
                    <div className="footer">
                        <Space>
                            <Button onClick={() => setIsFormVisible(false)}>
                                Cancel
                            </Button>

                            {!isEditMode && <Button>Save as Draft</Button>}

                            <Button onClick={handleSave}>
                                {isEditMode ? "Save" : "Publish"}
                            </Button>
                        </Space>
                    </div>
                </>
            )}
        </Wrapper>
    );
};

export default AddEditAnnouncement;

/* ================= STYLED COMPONENT ================= */

const Wrapper = styled.div`
  padding: 0px 0px;
  background: #fff;
  min-height: 100vh;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    }

    .back-dashboard {
    color: #1677ff;
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    }

  p {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 20px 0;
  }

  .filter-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    }

    .left-filters {
    display: flex;
    gap: 16px;
    }

    .right-controls {
    display: flex;
    align-items: center;
    gap: 20px;
    }

    .input {
    width: 220px;
    border-radius: 8px;
    }

    .select {
    width: 160px;
    }

  .ant-btn {
    border-radius: 8px;
    height: 34px;
  }

  .breadcrumb {
    font-size: 16px;
    margin-bottom: 30px;
  }

  .parent {
    color: #6b7280;
    cursor: pointer;
  }

  .divider {
    margin: 0 8px;
    color: #9ca3af;
  }

  .active {
    font-weight: 600;
  }

  .form-row {
    margin-bottom: 24px;
  }

  .form-section {
    margin-bottom: 24px;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
  }

  textarea,
  .ant-input,
  .ant-select-selector {
    border-radius: 8px !important;
  }

  .footer {
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;
  }
`;
